<template>
    <div>

        <div v-if="extinguisherLoading">
            <div class="row">
                <div class="col-md-12 text-center pt-5 pb-5 mt-5 pb-5">
                    <i class="fa fa-circle-notch fa-spin fa-10x fa-fw" aria-hidden="true"></i>
                </div>
            </div>
        </div>

        <div v-if="extinguisherFound === false && extinguisherLoading === false">
            <div class="row pb-4">
                <div class="col-md-8">
                    <h2 class="page-header-title">Sorry...</h2>
                </div>
            </div>
            <div class="widget">
                <div class="widget-body">
                    <p>The extinguisher could not be found. Please check the URL and try again.</p>
                    <p> <router-link to="/">Return Home</router-link></p>
                </div>
            </div>
        </div>

        <div v-if="extinguisher">

            <div class="row pb-4">
                <div class="col-md-10">
                    <h2 class="page-header-title">
                        <router-link to="/extinguisher-reports">Extinguisher Inspections</router-link>
                        &raquo;
                        <router-link :to="{ name: 'extinguisher-report-view', params: {action: 'view', id: extinguisherReport.site_extinguisher_report_id} }">
                            {{ extinguisherReport.job_number }} | {{ extinguisherReport.prepared_for }}
                        </router-link>
                        &raquo;
                        {{ extinguisher.extinguisher_identifier }} | {{ extinguisher.extinguisher_location }}        </h2>
                </div>
                <div class="col-md-2">
                    <router-link :to="{ name: 'extinguisher-report-edit-extinguisher', params: {id: parseInt(extinguisher.site_extinguisher_report_item_id)} }" class="btn btn-outline-secondary btn-square btn-lg pull-right">
                        Edit Extinguisher
                    </router-link>
                </div>
            </div>


            <div class="widget">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>Extinguisher Details</h3>
                </div>
                <div class="widget-body">
                    <table class="table table-bordered">
                        <tbody>
                        <tr>
                            <td><strong>Extinguisher ID</strong></td>
                            <td>{{ extinguisher.extinguisher_identifier }}</td>
                        </tr>
                        <tr>
                            <td><strong>Extinguisher Location</strong></td>
                            <td>{{ extinguisher.extinguisher_location }}</td>
                        </tr>
                        <tr>
                            <td><strong>Extinguisher Type</strong></td>
                            <td>{{ extinguisher.extinguisher_type }}</td>
                        </tr>
                        <tr>
                            <td><strong>Extinguisher Capacity</strong></td>
                            <td>{{ extinguisher.extinguisher_capacity }}</td>
                        </tr>
                        <tr>
                            <td><strong>Extinguisher Finish</strong></td>
                            <td>{{ extinguisher.extinguisher_finish }}</td>
                        </tr>
                        <tr>
                            <td><strong>Extinguisher Position</strong></td>
                            <td>{{ extinguisher.extinguisher_position }}</td>
                        </tr>
                        <tr>
                            <td><strong>Weight of Extinguisher Checked</strong></td>
                            <td>{{ extinguisher.weight_checked !== undefined ? extinguisher.weight_checked : '' }}</td>
                        </tr>
                        <tr>
                            <td><strong>Tamper Tag Replaced</strong></td>
                            <td>{{ extinguisher.tamper_tag_replaced !== undefined ? extinguisher.tamper_tag_replaced : '' }}</td>
                        </tr>
                        <tr>
                            <td><strong>Signage Present?</strong></td>
                            <td>
                                <span v-if="extinguisher.is_signage_present" class="c-positive">Yes</span>
                                <span v-else class="c-negative">No</span>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Extinguisher Condition</strong></td>
                            <td>
                                <span v-if="extinguisher.extinguisher_condition !== null" v-bind:class="extinguisher.extinguisher_condition === 'Pass' ? 'c-positive' : (extinguisher.extinguisher_condition === 'Condemned' ? 'c-negative' : 'c-warning')">{{ extinguisher.extinguisher_condition }}</span>
                                <span v-else class="c-neutral">&nbsp;</span>
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Extinguisher Extended Service Date</strong></td>
                            <td>{{ extinguisher.extinguisher_extended_service_date | formatDate }}</td>
                        </tr>
                        <tr v-if="extinguisher.additional_comments != null">
                            <td><strong>Additional Comments</strong></td>
                            <td>
                                <p>{{ extinguisher.additional_comments }}</p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>


            <div class="widget" v-if="extinguisher.extinguisher_offline_image == null && extinguisher.extinguisher_image != null">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>Extinguisher Photo</h3>
                </div>
                <div class="widget-body">
                    <div class="row">
                        <div class="col-sm-3 pb-3 entity-row-6" >
                            <img class="img-fluid" v-bind:src="this.cmsUrl + extinguisher.extinguisher_image">
                        </div>
                    </div>
                </div>
            </div>

            <div class="widget" v-if="extinguisher.extinguisher_offline_image != null">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>Offline Photo</h3>
                </div>
                <div class="widget-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="alert alert-warning">
                                <p class="mb-0 pb-0">Image in this section has not yet been synced with the server.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">

                        <div class="col-sm-3 pb-3 entity-row-6">
                            <img v-bind:src="extinguisher.extinguisher_offline_image.data" class="img-fluid">
                            <div class="image-actions">
                                <button v-on:click="rotatePhoto(-90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Anti-clockwise"><i class="fa fa-undo"></i></button>
                                <button v-on:click="rotatePhoto(90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Clockwise"><i class="fa fa-undo fa-flip-horizontal"></i></button>
                            </div>
                            <button v-on:click="removePhoto()" :disabled="modifyingPhoto" class="btn btn-outline-danger btn-square mt-3 w-100">Remove Photo</button>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xl-12 col-md-12 col-sm-12">
                    <div class="widget has-shadow">
                        <div class="widget-body border-bottom">
                            <router-link :to="{ name: 'extinguisher-report-add-extinguisher', params: {id: extinguisherReport.site_extinguisher_report_id} }" class="btn btn-outline-primary btn-square pt-3 pb-3 mt-3 mb-3" style="display:block;width:100%">
                                Add Extinguisher
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    import ImageRotate from '@/components/mixins/ImageRotate.js'

    export default {
        mixins: [ImageRotate],
        data() {
            return {
                extinguisher: null,
                extinguisherFound: false,
                extinguisherLoading: true,
                extinguisherReport: {
                    extinguisher_report_id: null,
                    job_number: 'Loading...',
                    prepared_for: 'Please wait...',
                    site_extinguisher_report_id: null,
                },
                modifyingPhoto: false,
                site_extinguisher_report_id: null
            }
        },
        methods: {
            getExtinguisher() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    try {
                        var extinguisherId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('extinguisher_report_items').objectStore('extinguisher_report_items');
                        var storeRequest = objectStore.get(extinguisherId);
                        storeRequest.onsuccess = function(event) {
                            vm.extinguisher = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                vm.getExtinguisherReport();
                                vm.extinguisherFound = true;
                                vm.site_extinguisher_report_id = storeRequest.result.site_extinguisher_report_id;
                            }
                            vm.extinguisherLoading = false;
                        };
                        storeRequest.onerror = function(e) {
                            vm.extinguisherFound = false;
                            vm.extinguisherLoading = false;
                        }
                    } catch (e) {
                        console.log(e);
                    }

                })
            },
            getExtinguisherReport() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    try {
                        var reportId = vm.extinguisher.site_extinguisher_report_id;
                        var objectStore = db.transaction('extinguisher_reports').objectStore('extinguisher_reports');
                        var storeRequest = objectStore.get(reportId);
                        storeRequest.onsuccess = function(event) {
                            vm.extinguisherReport = storeRequest.result;
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                })
            },
            removePhoto() {
                this.modifyingPhoto = true;
                var vm = this;
                this.getDb(function onConnectedGetDoorSets(db) {
                    var putRequest = db.transaction('extinguisher_report_items', 'readwrite')
                        .objectStore('extinguisher_report_items').put({
                            extinguisher_report_item_id: vm.extinguisher['extinguisher_report_item_id'],
                            site_extinguisher_report_item_id: parseInt(vm.extinguisher['site_extinguisher_report_item_id']),
                            site_extinguisher_report_id: parseInt(vm.extinguisher['site_extinguisher_report_id']),
                            extinguisher_report_id: vm.extinguisher['extinguisher_report_id'],
                            extinguisher_identifier: vm.extinguisher['extinguisher_identifier'],
                            extinguisher_location: vm.extinguisher['extinguisher_location'],
                            extinguisher_type: vm.extinguisher['extinguisher_type'],
                            extinguisher_capacity: vm.extinguisher['extinguisher_capacity'],
                            extinguisher_finish: vm.extinguisher['extinguisher_finish'],
                            extinguisher_position: vm.extinguisher['extinguisher_position'],
                            weight_checked: vm.extinguisher['weight_checked'] !== undefined ? vm.extinguisher['weight_checked'] : null,
                            tamper_tag_replaced: vm.extinguisher['tamper_tag_replaced'] !== undefined ? vm.extinguisher['tamper_tag_replaced'] : null,
                            extinguisher_extended_service_date: vm.extinguisher['extinguisher_extended_service_date'],
                            is_signage_present: vm.extinguisher['is_signage_present'],
                            extinguisher_condition: vm.extinguisher['extinguisher_condition'],
                            extinguisher_image: vm.extinguisher['extinguisher_image'],
                            additional_comments: vm.extinguisher['additional_comments'],
                            user_id: vm.extinguisher['user_id'],
                            extinguisher_offline_image: null
                        });
                    putRequest.onsuccess = function(event) {
                        vm.modifyingPhoto = false;
                    };
                    putRequest.onerror = function(event) {
                        alert("Unable to remove photo");
                        window.location = '';
                    };
                });
            },
            rotatePhoto(degrees) {
                this.modifyingPhoto = true;
                this.rotateImage(this.extinguisher.extinguisher_offline_image.data, degrees).then(newDataUri => {
                    this.extinguisher.extinguisher_offline_image.data = newDataUri;

                    var vm = this;
                    this.getDb(function onConnectedGetDoorSets(db) {
                        var putRequest = db.transaction('extinguisher_report_items', 'readwrite')
                            .objectStore('extinguisher_report_items').put({
                                extinguisher_report_item_id: vm.extinguisher['extinguisher_report_item_id'],
                                site_extinguisher_report_item_id: parseInt(vm.extinguisher['site_extinguisher_report_item_id']),
                                site_extinguisher_report_id: parseInt(vm.extinguisher['site_extinguisher_report_id']),
                                extinguisher_report_id: vm.extinguisher['extinguisher_report_id'],
                                extinguisher_identifier: vm.extinguisher['extinguisher_identifier'],
                                extinguisher_location: vm.extinguisher['extinguisher_location'],
                                extinguisher_type: vm.extinguisher['extinguisher_type'],
                                extinguisher_capacity: vm.extinguisher['extinguisher_capacity'],
                                extinguisher_finish: vm.extinguisher['extinguisher_finish'],
                                extinguisher_position: vm.extinguisher['extinguisher_position'],
                                extinguisher_extended_service_date: vm.extinguisher['extinguisher_extended_service_date'],
                                is_signage_present: vm.extinguisher['is_signage_present'],
                                extinguisher_condition: vm.extinguisher['extinguisher_condition'],
                                extinguisher_image: vm.extinguisher['extinguisher_image'],
                                additional_comments: vm.extinguisher['additional_comments'],
                                user_id: vm.extinguisher['user_id'],
                                extinguisher_offline_image: vm.extinguisher['extinguisher_offline_image']
                            });
                        putRequest.onsuccess = function(event) {
                            vm.modifyingPhoto = false;
                        };
                        putRequest.onerror = function(event) {
                            alert("Unable to rotate photo");
                            window.location = '';
                        };
                    });
                }).catch(e => {
                    console.log(e);
                    alert('Error occurred while trying to rotate photo');
                    this.modifyingPhoto = false;
                });
            },
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FER') === -1) {
                this.$router.push('/');
                return;
            }
            
            this.getExtinguisher();
        },
    }
</script>